module.exports = __webpack_public_path__ + "img/PL08600.13fb9806.png";